import { type ReactNode, useEffect, useState } from 'react';

interface DeferredComponentProps {
  children: ReactNode;
  delay?: number;
}

export const DeferredComponent = ({ children, delay = 200 }: DeferredComponentProps) => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsReady(true);
    }, delay);

    return () => clearTimeout(timer);
  }, []);

  if (!isReady) {
    return null;
  }

  return <>{children}</>;
};
